import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    const data = findWork(works, this.props.route.page.path);
    
    this.galleries = [
      [
        { src: this.prefixPath('dashboard.png'), caption: 'Overall dashboard' },
        { src: this.prefixPath('project-turnaroud.png'), caption: 'Project dashboard' },
        { src: this.prefixPath('entrepreneur-detail-history.png'), caption: 'Participant profile' },
        { src: this.prefixPath('entrepreneur-detail.png'), caption: 'Participant KPIs' },
        { src: this.prefixPath('pracharat-shops-detail.png'), caption: 'Pracharat shops' }
      ]
    ];

    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Description</h2>
            </div>
            <p>
              In 2016, the Office of Small and Medium Enterprises Promotion (OSMEP), in collaboration with partnering agencies, has rolled out several major plans to promote the SMEs of Thailand. Altogether, the plans would invest over 200 million baht to more than 10,000 businesses and startups nationwide. According to the scale of the project, a unified analytics system has to be developed in order to give an overview of the efficacy of the promotional plans.
            </p>
            <br />

            <p>
              In this project, I worked with a team at Runnables to develop a customized business intelligence system for OSMEP. Our system integrates multiple types of data from different stakeholders and turns them into useful insights into the efficacy of the promotional plans.
            </p>
            <br />

            <p>
              I designed the user experience of the web application and worked with the Database and Statistics Division at OSMEP to come up with relevant key performance indicators (KPIs) and their visualizations. 
            </p>
            <br />
            <img src={this.prefixPath('osmep-sme-tracking-iso-done.jpg')} />
          </div>

          <div className="section center">
            <h3>Selected Keyframes</h3>
          </div>

          <div className="section">
            <Gallery images={this.galleries[0]} />
          </div>

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Pakakorn Sithisak (Project Manager, Backend Developer)</li>
              <li>Sarawoot Piya-arayanunt (Full Stack Developer)</li>
              <li>Soravis Prakkamakul (UX/UI Designer)</li>
            </ul>
          </div>
          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/osmep-sme-tracking/index.jsx
 **/